import { Injectable } from '@angular/core';

export enum SpaceType {
  row = 'row',
  column = 'column'
}

export class Style {
  background: string
  width: string
  height: string
}

@Injectable({
  providedIn: 'root'
})
export class HdSpaceService {

  constructor() { }

}
